import {
	ACCESS_ROUTE,
	ADDITIONAL_INFO,
	CAREER_HISTORY_LIST,
	EDUCATION_INFO,
	ETC_INFO,
	FAMILY_RELATIONSHIPS,
	FINANCIAL_CONSULTANT,
	INSURANCE_EXPERIENCE,
	MODIFY_CORPORATION_INFO,
	PERSONAL_INFO,
	REGISTER_APPROVAL_BASIC_INFO,
	TAX_ACCOUNTANT_REGISTRATION_INFO
} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	basicInformation: REGISTER_APPROVAL_BASIC_INFO,
	certificate: z.array(z.string()).nullable(),
	corporationInformation: MODIFY_CORPORATION_INFO.nullable(),
	insuranceExperienceInformation: INSURANCE_EXPERIENCE.nullable(),
	accessRouteInformation: ACCESS_ROUTE.nullable(),
	gStarClubs: z.preprocess<string[], z.ZodArray<z.ZodString>, string[]>((val) => val ?? [], z.array(z.string())),
	familyInformation: FAMILY_RELATIONSHIPS.nullable(),
	personalInformation: PERSONAL_INFO,
	additionalInformation: ADDITIONAL_INFO.nullable(),
	fcRegistrationInformations: FINANCIAL_CONSULTANT.nullable(),
	etcInformation: ETC_INFO.nullable(),
	careerInformations: CAREER_HISTORY_LIST.nullable(),
	educationInformations: EDUCATION_INFO.nullable(),
	registrationInformation: TAX_ACCOUNTANT_REGISTRATION_INFO.nullable(),
	manualUpdateDate: z.string().optional().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const RegisterV2Dto = { schema, model };
export type IRegisterV2Dto = z.infer<typeof RegisterV2Dto.model>;

export const DEFAULT_REGISTER_V2_DTO: IRegisterV2Dto = {
	basicInformation: {
		manager: {
			id: "",
			name: "",
			startDate: "",
			endDate: ""
		},
		name: null,
		nameBeforeModified: null,
		companyStatus: "UNKNOWN",
		status: "UNKNOWN",
		areaBlock: null,
	},
	certificate: [],
	corporationInformation: null,
	insuranceExperienceInformation: null,
	accessRouteInformation: null,
	gStarClubs: [],
	familyInformation: null,
	personalInformation: {
		genderCode: null,
		gender: "UNKNOWN",
		birthday: null,
		realBirthday: null,
		birthdayType: null,
		birthplace: null,
		phone: null,
		email: null,
		religion: null,
		bloodType: null,
		twelveZodiacAnimal: null,
		golfPreference: null,
		golfHandicaps: [],
		// hobby: "",
		hobbies: []
	},
	additionalInformation: null,
	fcRegistrationInformations: [],
	etcInformation: null,
	careerInformations: [],
	educationInformations: [],
	registrationInformation: null,
	manualUpdateDate: null
};
